// Getter Object for ShopsDistribution. Use it by calling mapGetters from the Vuex Host Components.

export const shopsDistributionGetters = {
  shopsData: state => state.shopsData,
  shopList: state => state.shopList,
  shopDetails: state => state.shopDetails
};
